import PagesServices from "../../services/PagesServices";
import { isSet } from "../../Utils/CommonFunctions";
import { getGoBackURL, setGoBackURL } from "../../Utils/UserFunctions";
import { 
  SET_FROM_MAPPING,
  SET_RESOURCES_LIST,
  UPDATE_FROM_MAPPING_FIELDS,
  REMOVE_FROM_MAPPING_FIELD,
  SET_TO_PAGES,
  SET_TO_MAPPING,
  UPDATE_TO_MAPPING_FIELDS,
  REMOVE_TO_MAPPING_FIELD,
  SET_TO_PAGE_CONDITION,
  CLEAR_PAGES_CONFIG,
  REMOVE_TO_PAGES,
  LOAD_CONFIG_COLLECTION,
  SET_ACTIVE_CONFIG_PAGE,
  REMOVE_ACTIVE_POPUP_PAGE,
  SET_RESOURCES_LIST_BY_TYPE,
  UPDATE_PAGE_FLOWS_DATA,
  RESTORE_PAGE_FLOWS,
  SET_HISTORY_PAGE_FLOWS,
  GO_TO_HISTORY_PAGE_FLOWS
} from "../actionTypes/PagesActionTypes";

//SET SHIPPING DETAILS PAYLOAD
export const setFromMappingPayloadAction = (payload) => {
    return { 
      type: SET_FROM_MAPPING, 
      payload:payload
    };
  };

export const setToMappingPayloadAction = (pageIndex,newFieldMappings)=>{
  return{
    type:SET_TO_MAPPING,
    payload:{
      pageIndex,
      newFieldMappings
    }
  }
}

export const setResourcesListAction = (payload) =>{
  return{
    type:SET_RESOURCES_LIST,
    payload:payload
  }
}

export const setResourcesListByTypesAction = (inputs,outputs)=>{
  return{
    type:SET_RESOURCES_LIST_BY_TYPE,
    payload:{
      inputsVar:inputs,
      outputsVar:outputs
    }
  }
}
export const updateFromMappingFieldsAction = (index,value)=>{
  return{
    type:UPDATE_FROM_MAPPING_FIELDS,
    payload:{
      fromIndex:index,
      fromValue:value
    }
  }
}


export const updateToMappingFieldsAction = (pageIndex,index,value)=>{
  return{
    type:UPDATE_TO_MAPPING_FIELDS,
    payload:{
      pageIndex,pageIndex,
      toIndex:index,
      toValue:value
    }
  }
}

export const removeFromMappingFieldAction =(index)=>{
  return{
    type:REMOVE_FROM_MAPPING_FIELD,
    payload:{
      fromRemoveIndex:index
    }
  }
}


export const removeToMappingFieldAction = (pageIndex,index)=>{
  return{
    type:REMOVE_TO_MAPPING_FIELD,
    payload:{
      pageIndex:pageIndex,
      toRemoveIndex:index
    }
  }
}


export const setToPagesAction =(payload)=>{
  return{
    type: SET_TO_PAGES,
    payload:payload
  }
}

export const removeToPagesAction = (toPageIndex)=>{
  return{
    type:REMOVE_TO_PAGES,
    payload:{
      toPageIndex
    }
  }
}
  
export const setToPagesCondition = (pageIndex,condition)=>{
  return{
    type:SET_TO_PAGE_CONDITION,
    payload:{
      pageIndex,
      condition
    }
  }
}
export const clearPagesConfiguration = ()=>{
  return{
    type:CLEAR_PAGES_CONFIG
  }
}

export const setPagesHistoryConfigAction = ()=>{
  return {
    type:SET_HISTORY_PAGE_FLOWS,

  }
}

export const goToHistoryPageAction  =()=>{
  return{
    type:GO_TO_HISTORY_PAGE_FLOWS
  }
}


// RENDER PAGES BLOCK


export const loadPagesConfigAction = (searchBy,configId,history,onload=false,pType='DEFAULT',action=null,obj=null) => {
  return async (dispatch,getState) => {
    const current = window.location?.pathname;
    const urls = getGoBackURL?.() || [];

    if (current && urls.length === 0) {
      setGoBackURL(current);
    }

    const getStates = getState();
    const configs = isSet(getStates?.PagesReducer?.pageFlows?.[configId],null);
    // console.log('getState',searchBy,configId,history,onload);
    // console.log('configs',configs);
    // return false;
    // if(configs===null)
    // if(configs!==null && refetch===false){ return false; }
    if(onload===false){
      dispatch({ type: "LOADER", bool: true });
    }
    let response;
    //API_NAME
    try {
      if(searchBy === 'ID'){
        response = await PagesServices.getConfigById(configId);
      }else{
        response = await PagesServices.getConfigByName(configId);
      }
      dispatch({ type: "LOADER", bool: false });
      if(response?.code===200 && response?.data){
        const responseData = response?.data;        
        // console.log('responseData',responseData); SAME_WINDOW SEPARATE_WINDOW POPUP
        let outputVariables = {};        
        if(responseData?.config_type==="DIRECT"){
          try{
            const postData = {
            actionComponentId: action?.id,
            layoutId: obj?.layoutId,
            windowId: obj?.windowId,
            ids: obj?.val
          }
          const directResponse = obj!=null ? await PagesServices.getConfigDirect(configId, postData) : null;
          
          // Transform the directResponse to outputVariables format
          if (directResponse && directResponse.data) {
            Object.keys(directResponse.data).forEach((uuidKey) => {
              const variableArray = directResponse.data[uuidKey];
              if (Array.isArray(variableArray)) {
                variableArray.forEach((variable) => {
                  if (variable.variable_name) {
                    outputVariables[variable.variable_name] =
                      variable.selected_value ?? variable.value;
                  }
                });
              }
            });
          }
            if (Object.keys(outputVariables).length > 0) {
              const dataToStoreForChildOutput = {
                pageId: responseData?.id,
                outputResponse: outputVariables
              };
              localStorage.setItem('directApiOutputForChildWindow', JSON.stringify(dataToStoreForChildOutput));
            }
            if (obj === null && Object.keys(outputVariables).length === 0) {
              const storedOutputStr = localStorage.getItem('directApiOutputForChildWindow');
              if (storedOutputStr) {
                try {
                  const storedOutputData = JSON.parse(storedOutputStr);
                  if (storedOutputData.pageId === responseData?.id) {
                    outputVariables = storedOutputData.outputResponse;
                  }
                  localStorage.removeItem('directApiOutputForChildWindow');
                } catch (parseError) {
                  console.error("Error parsing stored directApiOutputForChildWindow:", parseError);
                  localStorage.removeItem('directApiOutputForChildWindow');
                }
              }
            }
        }catch(error){
          console.log('error',error);
        }
            const pages = responseData?.pages;
            if(pages?.display_type==='SAME_WINDOW' && onload===false){
              //configuration_api_name
              history.push(`/pages/page/${responseData?.configuration_api_name}`)
            }else if(pages?.display_type==='SEPARATE_WINDOW' && onload===false){
                const url = `/pages/window/${responseData?.configuration_api_name}`;
              const { format, width, height } = pages;
              let screenwidth;
              let screenheight;
              let topPosition = 100;
              let leftPosition = 100;

              if (format === "CUSTOM") {
                screenwidth = width;
                screenheight = height;
              } else {
                screenwidth = window.screen.availWidth;
                screenheight = window.screen.availHeight;
              }

              if (window.opener) { window.close(); }
              const windowFeature = `width=${screenwidth},height=${screenheight},top=${topPosition},left=${leftPosition},resizable=no,scrollbars=yes,location=no,status=no`;

              const forceResize = (win) => {
                // setTimeout(() => {
                  if (!win.closed) {
                    win.resizeTo(screenwidth, screenheight);
                    // win.moveTo(leftPosition, topPosition);
                    win.focus();
                  }
                // }, 10);
              };

              if (window.childWindow && !window.childWindow.closed) {
                window.childWindow.location.href = url;
                forceResize(window.childWindow);
              } else {
                //Open new window
                window.childWindow = window.open(
                  url,
                  pages.page_name,
                  windowFeature
                );
                //Force resize/reposition
                // if (window.childWindow) {
                //   forceResize(window.childWindow);
                // }
              }

                // const {format,width,height} = pages;
                // let screenwidth =null;//window.screen.availWidth; //null;// 800;
                // let screenheight = null;//window.screen.availHeight;// 600;
                // if(format==="CUSTOM"){
                //   screenwidth = width;
                //   screenheight = height;
                // }
                // else{
                //   // screenwidth=window.screen.availWidth;
                //   // screenheight =window.screen.availHeight;// 600;
                // }
                // if(window.opener){window.close();}
                // // console.log('pages',pages);
                // const windowFeature= `width=${screenwidth},height=${screenheight},top=100,left=100,resizable=no,scrollbars=yes,location=no,status=no`;
                // if (window.childWindow && !window.childWindow.closed) {
                //   window.childWindow.location.href = url; // reload the new URL
                //   window.childWindow.resizeTo(screenwidth, screenheight);
                //   // window.childWindow.moveTo(100, 100);
                //   window.childWindow.focus();
                // } else {
                  
                //   window.childWindow = window.open(
                //     url,
                //     pages.page_name, // window name
                //    windowFeature
                //   );
                // }



                // const childWindow = window.open(
                //     url,
                //     pages.page_name, // window name
                //     `width=${screenwidth},height=${screenheight},top=100,left=100,resizable=no,scrollbars=yes,location=no,status=no`
                // );
                // -------------------------
                //  childWindow.sharedHistoryPush = (path) => {
                //   console.log('pages....');
                //   history.push(path); // parent navigates
                // };
            }
            
            if(onload===false || pType==='RENDER'){
              // Merge outputVariables into collections object (consistent with existing pattern)
              const collectionsWithOutput = {
                ...response.data,
                ...(Object.keys(outputVariables).length
                ? { outputVariables: { ...outputVariables } }
                : {})
              };
              dispatch(loadPageConfigCollectionAction(collectionsWithOutput,searchBy,response?.data?.configuration_api_name));
            }
            
        }else{
          const variableResponse = await PagesServices.getConfigVariablesList(responseData?.id);
          // variableResponse?.data?.content
          console.log('variableResponse',variableResponse?.data?.content);
          let inputVariables = [];
          let outputVariables = [];
          variableResponse?.data?.content.forEach((vari)=>{
            if(vari.is_request===true){
              inputVariables.push({
                ...vari,type:vari.fieldtype_name
              });
            }else{
              outputVariables.push({
                ...vari,type:vari.fieldtype_name
              });
            }
          });
          // console.log('inputVariables',inputVariables);
          dispatch(setResourcesListByTypesAction(inputVariables,outputVariables));
          dispatch(loadPageConfigCollectionAction(response.data,searchBy,response?.data?.configuration_api_name));
          // setResourcesListByTypesAction
        }
        // dispatch({ type: "LOAD_CONFIG_COLLECTION", payload: {
        //   collections:response.data,
        //   identifer:searchBy,
        //   configKey:response?.data?.configuration_api_name
        // } })
      }
      // console.log('response',response);
      // dispatch({ type: "API_SUCCESS", payload: response.data });
    } catch (error) {
      // dispatch({ type: "API_FAILURE", error });
    }
  };
};

export const restorePageFlowsAction = ()=>{
  return{
    type:RESTORE_PAGE_FLOWS,
    payload:{}
  }
}

export const loadPageConfigCollectionAction =(collections,searchBy,configKey)=>{
  console.log(" collect ---" , collections , searchBy , configKey);
  
  return{
    type:LOAD_CONFIG_COLLECTION,
    payload:{
          collections:collections,
          identifer:searchBy,
          configKey:configKey
        }
  }
}

export const setActiveConfigPagesAction = (type,page)=>{
  return{
    type:SET_ACTIVE_CONFIG_PAGE,
    payload:{
      pageDesignType:type,
      pageConfigKey:page
    }
  }
}

export const removeActivePopupPageAction =(configKey)=>{
  return{
    type:REMOVE_ACTIVE_POPUP_PAGE,
    payload:{
      removingConfigKey:configKey
    }
  }
}

export const updatePageFlowsDataAction = (apiName,key,data)=>{
  return{
    type:UPDATE_PAGE_FLOWS_DATA,
    payload:{
      configApiName:apiName,
      pageDataKey:key,
      pageDataValue:data
    }
  }
}
// END OF RENDER PAGES BLOCK
